import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps { }
export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
  type: 'checkbox-read' | Type<CheckboxReadType>;
}
@Component({
  selector: 'checkbox-read-type',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  template: `
    <div *ngIf="field.formControl.value" class="my-6">
      <div class="max-w-full flex flex-row items-center space-y-1 text-gray-500  dark:text-gray-400 ">
        <mat-icon class="icon-size-5 mr-2" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
        <span class="">{{field.props.label}}</span>
      </div>
    </div>
  `,
  imports: [NgIf, MatIconModule]
})
export class CheckboxReadType extends FieldType<FieldTypeConfig<InputProps>>{


}
